import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { verifyPermission } from "../../helpers/permission";
import InfirmationTable from "../components/InfirmationTable";
import HeaderTablePage from "../components/HeaderTablePage";
import LoadingTable from "../components/LoadingTable";
import EmptyTable from "../components/EmptyTable";
import Pagination from "../components/Pagination";
import { ERROR_401 } from "../../config/errorPage";
import appConfig from "../../config/appConfig";
import {
  forceRound,
  formatDateToTime,
  getLowerCaseString,
  loadCss,
  showDatePassed,
} from "../../helpers/function";
import { NUMBER_ELEMENT_PER_PAGE } from "../../constants/dataTable";
import { verifyTokenExpire } from "../../middleware/verifyToken";
import { ToastBottomEnd } from "../components/Toast";
import { toastSuccessMessageWithParameterConfig } from "../../config/toastConfig";
import FileSaver from "file-saver";
import { useTranslation } from "react-i18next";
import moment from "moment";

loadCss("/assets/plugins/custom/datatables/datatables.bundle.css");

const TODAY = moment().format("YYYY-MM-DD");

const ClaimMonitoringSuiviUnite = (props) => {
  //usage of useTranslation i18n
  const { t, ready } = useTranslation();

  if (!props.activePilot && !verifyPermission(props.userPermissions, "show-unit-monitoring"))
    window.location.href = ERROR_401;

  const [load, setLoad] = useState(true);
  const [claims, setClaims] = useState([]);
  const [numberPerPage, setNumberPerPage] = useState(10);
  const [activeNumberPage, setActiveNumberPage] = useState(1);
  const [numberPage, setNumberPage] = useState(0);
  const [showList, setShowList] = useState([]);
  const [dateStart, setDateStart] = useState(null);
  const [dateEnd, setDateEnd] = useState(null);
  const [error, setError] = useState({
    date_start: [],
    date_end: [],
    institution_id: [],
  });
  const [loadFilter, setLoadFilter] = useState(false);
  const [loadDownload, setLoadDownload] = useState(false);
  const [loadDownloadPdf, setLoadDownloadPdf] = useState(false);
  const [institution, setInstitution] = useState(null);
  // const [institutions, setInstitutions] = useState([]);

  const fetchData = async (click = false) => {
    setLoadFilter(true);
    setLoad(true);
    let endpoint = "";
    let sendData = {};
    if (
      props.activePilot === true || verifyPermission(props.userPermissions, "show-unit-monitoring")
    ) {
      if (props.plan === "MACRO")
        endpoint = `${appConfig.apiDomaine}/my/monitoring-suivi-unite`;
      else endpoint = `${appConfig.apiDomaine}/without/monitoring-suivi-unite`;
      sendData = {
        date_start: dateStart,
        date_end: dateEnd,
      };
    } else if (
      props.activePilot === false
    ) {
      endpoint = `${appConfig.apiDomaine}/my/monitoring-suivi-unite`;
      sendData = {
        date_start: dateStart,
        date_end: dateEnd,
      };
    }
    await axios
      .get(endpoint, { params: sendData })
      .then((response) => {
        if (click)
          ToastBottomEnd.fire(
            toastSuccessMessageWithParameterConfig(
              ready ? t("Filtre effectué avec succès") : ""
            )
          );
        setNumberPage(forceRound(response.data.length / numberPerPage));
        setShowList(response.data.slice(0, numberPerPage));
        setClaims(response.data);
        setError({
          date_start: [],
          date_end: [],
          institution_id: [],
        });
        setLoadFilter(false);
        setLoad(false);
      })
      .catch((error) => {
        setError({
          ...error.response.data.error,
        });
        setLoadFilter(false);
        setLoad(false);
      });
  };

  useEffect(() => {
    if (verifyTokenExpire()) fetchData();
  }, [numberPerPage]);

//   useEffect(() => {
//     var endpoint = "";
//     // if (
//     //   props.activePilot === true
//     // ) {
//     //   if (props.plan === "MACRO")
//     //     endpoint = `${appConfig.apiDomaine}/any/uemoa/data-filter`;
//     //   else endpoint = `${appConfig.apiDomaine}/without/uemoa/data-filter`;
//     // }

//     // if (
//     //   props.activePilot === false
//     // )
//     //   endpoint = `${appConfig.apiDomaine}/my/uemoa/data-filter`;

//     if (verifyTokenExpire()) {
//       axios
//         .get(endpoint)
//         .then((response) => {
//           setInstitutions(
//             formatSelectOption(response.data.institutions, "name", false)
//           );
//         })
//         .catch((error) => { });
//     }
//   }, []);

  const filterShowListBySearchValue = (value) => {
    value = getLowerCaseString(value);
    let newClaims = [...claims];
    newClaims = newClaims.filter((el) => {
      return (
        getLowerCaseString(el.unit_name ? el.unit_name : "-").indexOf(value) >=
          0 ||
        getLowerCaseString(el.assigned_count + "").indexOf(value) >= 0 ||
        getLowerCaseString(el.treated_count + "").indexOf(value) >= 0 ||
        getLowerCaseString(el.not_treated_count + "").indexOf(value) >= 0 ||
        getLowerCaseString(el.satisfied_count + "").indexOf(value) >= 0 ||
        getLowerCaseString(el.duration_average + "").indexOf(value) >= 0
      );
    });

    return newClaims;
  };

  const searchElement = async (e) => {
    if (e.target.value) {
      setNumberPage(
        forceRound(
          filterShowListBySearchValue(e.target.value).length /
          NUMBER_ELEMENT_PER_PAGE
        )
      );
      setShowList(
        filterShowListBySearchValue(e.target.value.toLowerCase()).slice(
          0,
          NUMBER_ELEMENT_PER_PAGE
        )
      );
    } else {
      setNumberPage(forceRound(claims.length / NUMBER_ELEMENT_PER_PAGE));
      setShowList(claims.slice(0, NUMBER_ELEMENT_PER_PAGE));
      setActiveNumberPage(1);
    }
  };

  const onChangeNumberPerPage = (e) => {
    setActiveNumberPage(1);
    setNumberPerPage(parseInt(e.target.value));
    setShowList(claims.slice(0, parseInt(e.target.value)));
    setNumberPage(forceRound(claims.length / parseInt(e.target.value)));
  };

  // const onChangeInstitution = (selected) => {
  //   setInstitution(selected);
  // };

  const getEndByPosition = (position) => {
    let end = numberPerPage;
    for (let i = 1; i < position; i++) {
      end = end + numberPerPage;
    }
    return end;
  };

  const onClickPage = (e, page) => {
    e.preventDefault();
    setActiveNumberPage(page);
    setShowList(
      claims.slice(
        getEndByPosition(page) - numberPerPage,
        getEndByPosition(page)
      )
    );
  };

  const onClickNextPage = (e) => {
    e.preventDefault();
    if (activeNumberPage <= numberPage) {
      setActiveNumberPage(activeNumberPage + 1);
      setShowList(
        claims.slice(
          getEndByPosition(activeNumberPage + 1) - numberPerPage,
          getEndByPosition(activeNumberPage + 1)
        )
      );
    }
  };

  const onClickPreviousPage = (e) => {
    e.preventDefault();
    if (activeNumberPage >= 1) {
      setActiveNumberPage(activeNumberPage - 1);
      setShowList(
        claims.slice(
          getEndByPosition(activeNumberPage - 1) - numberPerPage,
          getEndByPosition(activeNumberPage - 1)
        )
      );
    }
  };

  const handleDateEndChange = (e) => {
    const value = e.target.value;

    // Empêcher une date de fin future
    if (value > TODAY) {
      setDateEnd(TODAY);
      return;
    }

    // Empêcher une date de fin antérieure à la date de début
    if (value < dateStart) {
      setDateEnd(dateStart);
      return;
    }

    setDateEnd(value);
  };

  const handleDateStartChange = (e) => {
    const value = e.target.value;

    // Empêcher une date de début future
    let nextStart = value > TODAY ? TODAY : value;
    setDateStart(nextStart);

    // S'assurer que la date de fin reste >= date de début
    if (dateEnd < nextStart) {
      setDateEnd(nextStart);
    }
  };

  const arrayNumberPage = () => {
    const pages = [];
    for (let i = 0; i < numberPage; i++) {
      pages[i] = i;
    }
    return pages;
  };

  const filterReporting = () => {
    setLoadFilter(true);
    setLoad(true);
    if (verifyTokenExpire()) fetchData(true);
  };

  const downloadReporting = () => {
    setLoadDownload(true);
    let endpoint = "";
    let sendData = {};
    if (
      props.activePilot === true || verifyPermission(props.userPermissions, "show-unit-monitoring")
    ) {
      if (props.plan === "MACRO")
        endpoint = `${appConfig.apiDomaine}/my/monitoring-suivi-unite`;
      else endpoint = `${appConfig.apiDomaine}/without/monitoring-suivi-unite`;
      sendData = {
        date_start: dateStart,
        date_end: dateEnd,
      };
    } else if (
      props.activePilot === false
    ) {
      endpoint = `${appConfig.apiDomaine}/my/monitoring-suivi-unite`;
      sendData = {
        date_start: dateStart,
        date_end: dateEnd,
      };
    }

    if (verifyTokenExpire()) {
      axios({
        method: "post",
        url: endpoint,
        responseType: "json",
        data: sendData,
      })
        .then(({ data }) => {
          setError({
            date_start: [],
            date_end: [],
            institution_id: [],
          });
          const downloadButton = document.getElementById("downloadButton");
          downloadButton.href = `${appConfig.apiDomaine}/download-uemoa-reports/${data.file}`;
          downloadButton.click();
          setLoadDownload(false);
          setLoadDownload(false);
          // ToastBottomEnd.fire(toastSuccessMessageWithParameterConfig('Téléchargement éffectuer avec succès'));
        })
        .catch((error) => {
          setError({
            ...error.response.data.error,
          });

          setLoadDownload(false);
        });
    }
  };

  const downloadReportingPdf = () => {
    setLoadDownloadPdf(true);
    let endpoint = "";
    let sendData = {};
    if (
      props.activePilot === true || verifyPermission(props.userPermissions, "show-unit-monitoring")
    ) {
      if (props.plan === "MACRO")
        endpoint = `${appConfig.apiDomaine}/my/monitoring-suivi-unite-pdf`;
      else
        endpoint = `${appConfig.apiDomaine}/without/monitoring-suivi-unite-pdf`;
      sendData = {
        date_start: dateStart,
        date_end: dateEnd,
      };
    } else if (
      props.activePilot === false
    ) {
      endpoint = `${appConfig.apiDomaine}/my/monitoring-suivi-unite-pdf`;
      sendData = {
        date_start: dateStart,
        date_end: dateEnd,
      };
    }

    if (verifyTokenExpire()) {
      axios({
        method: "post",
        url: endpoint,
        responseType: "blob",
        data: sendData,
      })
        .then(({ data }) => {
          setError({
            date_start: [],
            date_end: [],
            institution_id: [],
          });
          FileSaver.saveAs(
            data,
            `reporting_etat_analytique_${new Date().getFullYear()}.pdf`
          );
          setLoadDownloadPdf(false);
          // setLoadDownload(false);
          // ToastBottomEnd.fire(toastSuccessMessageWithParameterConfig('Téléchargement éffectuer avec succès'));
        })
        .catch((error) => {
          setError({
            date_start: "",
            date_end: "",
            institution_id: [],
            ...error.response.data.error,
          });

          setLoadDownloadPdf(false);
        });
    }
  };

  const pages = arrayNumberPage();

  const printBodyTable = (claim, index) => {
    return (
      <tr key={index} role="row" className="odd">
        <td>{claim.unit_name || "-"}</td>
        <td>{claim.assigned_count ?? 0}</td>
        <td>{claim.treated_count ?? 0}</td>
        <td>{claim.transferred_to_unit_count ?? 0}</td>
        <td>{claim.assign_to_staff_count ?? 0}</td>
        <td>{claim.satisfied_count ?? 0}</td>
        <td>
          {claim.duration_average != null && claim.duration_average !== ""
            ? Number(claim.duration_average).toFixed(2)
            : "-"}
        </td>
      </tr>
    );
  };

  return ready ? (
    props.activePilot === true || verifyPermission(props.userPermissions, "show-unit-monitoring") ? (
      <div
        className="kt-content  kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor"
        id="kt_content"
      >
        <div className="kt-subheader   kt-grid__item" id="kt_subheader">
          <div className="kt-container  kt-container--fluid ">
            <div className="kt-subheader__main">
              <h3 className="kt-subheader__title">{t("Processus")}</h3>
              <span className="kt-subheader__separator kt-hidden" />
              <div className="kt-subheader__breadcrumbs">
                <a href="#icone" className="kt-subheader__breadcrumbs-home">
                  <i className="flaticon2-shelter" />
                </a>
                <span className="kt-subheader__breadcrumbs-separator" />
                <a
                  href="#button"
                  onClick={(e) => e.preventDefault()}
                  className="kt-subheader__breadcrumbs-link"
                  style={{ cursor: "text" }}
                >
                  {t("Suivi des unités")}
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="kt-container  kt-container--fluid  kt-grid__item kt-grid__item--fluid">
          <InfirmationTable
            information={
              <div>
                {t(
                  "Suivi des unités "
                )}
              </div>
            }
          />

          <div className="kt-portlet">
            <HeaderTablePage title={t("Suivi des unités")} />

            <div className="kt-portlet__body">
              <div className="row align-items-end">
                <div className="col-md-8">
                  <div className="form-row">
                    <div className="form-group col-md-5">
                      <label>{t("Date de début")}</label>
                      <input
                        type="date"
                        className="form-control"
                        value={dateStart}
                        onChange={handleDateStartChange}
                        max={TODAY}
                      />
                      {error.date_start && error.date_start.length > 0 && (
                        <small className="form-text text-danger">
                          {error.date_start[0]}
                        </small>
                      )}
                    </div>
                    <div className="form-group col-md-5">
                      <label>{t("Date de fin")}</label>
                      <input
                        type="date"
                        className="form-control"
                        value={dateEnd}
                        onChange={handleDateEndChange}
                        min={dateStart}
                        max={TODAY}
                      />
                      {error.date_end && error.date_end.length > 0 && (
                        <small className="form-text text-danger">
                          {error.date_end[0]}
                        </small>
                      )}
                    </div>
                    <div className="form-group col-md-2 d-flex align-items-end">
                      <button
                        type="button"
                        className="btn btn-primary btn-block"
                        onClick={filterReporting}
                        disabled={loadFilter || load}
                      >
                        {loadFilter ? t("Filtrage...") : t("Filtrer")}
                      </button>
                    </div>
                  </div>
                </div>

                <div className="col-md-4">
                  <div className="d-flex justify-content-end mt-4 mt-md-0 mr-4">
                    <a
                      className="d-none"
                      href="#"
                      id="downloadButton"
                      download={true}
                    >
                      downloadButton
                    </a>

                    <button
                      onClick={downloadReporting}
                      className="btn btn-outline-success d-flex align-items-center ml-3"
                      disabled={loadFilter || loadDownloadPdf || loadDownload}
                      type="button"
                    >
                      {loadDownload ? (
                        <>
                          <span className="kt-spinner kt-spinner--sm kt-spinner--light mr-2" />
                          {t("Génération en cours")}
                        </>
                      ) : (
                        <>
                          <i className="la la-file-excel-o mr-2" />
                          {t("Exporter en Excel")}
                        </>
                      )}
                    </button>
                  </div>
                  </div>
                </div>
              </div>

              {load ? (
                <LoadingTable />
              ) : (
                <div className="kt-portlet__body">
                  <div
                    id="kt_table_1_wrapper"
                    className="dataTables_wrapper dt-bootstrap4 mt-4 "
                    style={{ paddingTop: "1.5rem" }}
                  >
                    <div className="row">
                      <div className="col-sm-6 text-left">
                        <div id="kt_table_1_filter" className="dataTables_filter">
                          <label>
                            {t("Rechercher")}:
                            <input
                              id="myInput"
                              type="text"
                              onKeyUp={(e) => searchElement(e)}
                              className="form-control form-control-sm"
                              placeholder=""
                              aria-controls="kt_table_1"
                            />
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-sm-12"
                        style={{
                          overflowX: "auto",
                        }}
                      >
                        <table
                          className="table table-striped table-bordered table-hover table-checkable dataTable dtr-inline"
                          id="myTable"
                          role="grid"
                          aria-describedby="kt_table_1_info"
                          style={{ width: "952px" }}
                        >
                          <thead>
                            <tr role="row">
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="kt_table_1"
                                rowSpan="1"
                                colSpan="1"
                                style={{ width: "120px" }}
                                aria-label="Country: activate to sort column ascending"
                              >
                                {t("Unité")}
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="kt_table_1"
                                rowSpan="1"
                                colSpan="1"
                                style={{ width: "80px" }}
                                aria-label="Country: activate to sort column ascending"
                              >
                                {t("Réclamations reçues")}
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="kt_table_1"
                                rowSpan="1"
                                colSpan="1"
                                style={{ width: "80px" }}
                                aria-label="Country: activate to sort column ascending"
                              >
                                {t("Réclamations traitées")}
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="kt_table_1"
                                rowSpan="1"
                                colSpan="1"
                                style={{ width: "80px" }}
                                aria-label="Country: activate to sort column ascending"
                              >
                                {t("Réclamations à dispatcher dans l'unité")}
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="kt_table_1"
                                rowSpan="1"
                                colSpan="1"
                                style={{ width: "80px" }}
                                aria-label="Country: activate to sort column ascending"
                              >
                                {t("Réclamations assignées au staff")}
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="kt_table_1"
                                rowSpan="1"
                                colSpan="1"
                                style={{ width: "80px" }}
                                aria-label="Country: activate to sort column ascending"
                              >
                                {t("Retours satisfaisants")}
                              </th>
                              <th
                                className="sorting"
                                tabIndex="0"
                                aria-controls="kt_table_1"
                                rowSpan="1"
                                colSpan="1"
                                style={{ width: "80px" }}
                                aria-label="Country: activate to sort column ascending"
                              >
                                {t("Temps moyen traitement (jours)")}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {claims.length ? (
                              showList.length ? (
                                showList.map((claim, index) =>
                                  printBodyTable(claim, index)
                                )
                              ) : (
                                showList.map((claim, index) =>
                                  printBodyTable(claim, index)
                                )
                              )
                            ) : (
                              <EmptyTable />
                            )}
                          </tbody>
                          <tfoot>
                            <tr>
                            <th rowSpan="1" colSpan="1">
                              {t("Unité")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Réclamations reçues")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Réclamations traitées")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Réclamations à dispatcher dans l'unité")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Réclamations assignées au staff")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Retours satisfaisants")}
                            </th>
                            <th rowSpan="1" colSpan="1">
                              {t("Temps moyen traitement (jours)")}
                              </th>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div
                          className="dataTables_info"
                          id="kt_table_1_info"
                          role="status"
                          aria-live="polite"
                        >
                          {t("Affichage de")} {showList.length}{" "}
                          {t("sur")} {claims.length} {t("données")}
                        </div>
                      </div>
                      {showList.length ? (
                        <div className="col-sm-12 col-md-7 dataTables_pager">
                          <Pagination
                            numberPerPage={numberPerPage}
                            onChangeNumberPerPage={onChangeNumberPerPage}
                            activeNumberPage={activeNumberPage}
                            onClickPreviousPage={(e) => onClickPreviousPage(e)}
                            pages={pages}
                            onClickPage={(e, number) => onClickPage(e, number)}
                            numberPage={numberPage}
                            onClickNextPage={(e) => onClickNextPage(e)}
                          />
                        </div>
                      ) : null}
                    </div>
                  </div>
                </div>
              )}
          </div>
        </div>
      </div>
    ) : null
  ) : null;
};

const mapStateToProps = (state) => {
  return {
    plan: state.plan.plan,
    userPermissions: state.user.user.permissions,
    activePilot: state.user.user.staff.is_active_pilot,
    userPermissions: state.user.user.permissions,
  };
};

export default connect(mapStateToProps)(ClaimMonitoringSuiviUnite);
